import CalendarView from "@/components/appointment/CalendarView";
import AgendasView from "@/components/appointment/AgendasView";
import ScheduleView from "@/components/appointment/ScheduleView";
import AppointmentsRelocationView from "@/components/appointment/AppointmentsRelocationView";
import AppointmentCancel from "@/components/appointment/AppointmentCancel";
import PatientAppointmentView from "@/components/patient/PatientAppointmentView";

const appointmentRoutes = [
  {
    path: "/appointment/calendar",
    name: "appointment-calendar",
    component: CalendarView,
  },
  {
    path: "/appointment/:appointmentId/cancel",
    name: "appointment-cancel",
    component: AppointmentCancel,
  },
  {
    path: "/appointment/agendas",
    name: "appointment-agendas",
    component: AgendasView,
  },
  {
    path: "/appointment/relocation",
    name: "appointment-relocation",
    component: AppointmentsRelocationView,
  },
  {
    path: "/appointment/schedule",
    name: "appointment-schedule",
    component: ScheduleView,
  },
  // {
  //   path: "/appointment/patient",
  //   name: "appointment-patient",
  //   component: PatientAppointmentsView,
  // },
  {
    path: "/appointment/:appointmentId",
    name: "appointment",
    component: PatientAppointmentView,
  },
];

export default appointmentRoutes;
